import { render, staticRenderFns } from "./category-drawer.vue?vue&type=template&id=2158b3ec&"
import script from "./category-drawer.vue?vue&type=script&lang=js&"
export * from "./category-drawer.vue?vue&type=script&lang=js&"
import style0 from "./category-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports